<div class="grid items-center justify-center grid-cols-2">

  <div>
      <canvas id="{{id}}" #donutchart total-eligible-voter="0"></canvas>
  </div>
  <div class="flex flex-col">
    <div *ngFor="let item of data" class="flex pt-4 pb-4 border-b border-b-gray-300 last:border-b-0">
      <div class="flex w-4/6">
        <div class="text-m material-symbols-rounded" [ngStyle]="{'color': getItemColor(item)}">{{item.icon}}</div>
        <div class="px-4" id="{{generateId(item.label)}}">{{item.label}}</div>
      </div>
      <div class="w-2/6 text-right ">
        <span class="mx-2 body-default-bold" id="{{generateId(item.label)}}_vote">{{item.value}}</span>
        <span *ngIf="showPercentage" class="text-grey-800" id="{{generateId(item.label)}}_vote_percentage">({{item.percentage}}%)</span>
      </div>
    </div>
  </div>

</div>
